import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  padding-bottom: 40px;\n  width: 100%;\n  /* https://stackoverflow.com/a/43809765 */\n  /* \u8BA9\u5185\u5BB9\u5BBD\u5EA6\u6070\u597D\u7B49\u4E8E\u53BB\u6389Side\u4EE5\u540E\u7684\u5269\u4F59\u5BBD\u5EA6 */\n  min-width: 0;\n  /* \u5141\u8BB8\u4E00\u4E9Bbox-shadow\u6EA2\u51FA */\n  overflow: visible;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  position: relative;\n  min-width: 180px;\n  padding-right: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  flex-grow: 1;\n  margin-bottom: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import Partial from './Partial';
import { flexContainer, flexItem } from './utils';
var Content = styled(Partial)(_templateObject(), flexContainer());
export var Side = styled.div(_templateObject2(), flexItem({
  flexShrink: 0
}));
export var Main = styled.div(_templateObject3(), flexItem({
  flexGrow: 1
}));
export default Content;